
import { BellDot } from "lucide-react";
import EmailNotification from "./EmailNotification";
import NotificationToggle from "./NotificationToggle";
import NoEmailWarning from "./NoEmailWarning";
import { AlertSettings } from "@/lib/types";

interface NotificationMethodsProps {
  settings: AlertSettings;
  onToggleEmailNotifications: (enabled: boolean) => void;
  onToggleInAppNotifications: (enabled: boolean) => void;
  userEmail: string | null;
}

const NotificationMethods = ({
  settings,
  onToggleEmailNotifications,
  onToggleInAppNotifications,
  userEmail
}: NotificationMethodsProps) => {
  return (
    <div className="space-y-4 pt-2 border-t">
      <h4 className="text-sm font-medium">Notification Methods</h4>
      
      <div className="space-y-4">
        <EmailNotification
          checked={settings.emailNotifications}
          onCheckedChange={onToggleEmailNotifications}
          disabled={!settings.enabled}
          userEmail={userEmail}
        />
        
        <NotificationToggle
          id="in-app-notifications"
          icon={<BellDot className="h-5 w-5 text-green-500" />}
          title="In-app Notifications"
          checked={settings.phoneNotifications}
          onCheckedChange={onToggleInAppNotifications}
          disabled={!settings.enabled}
        />
      </div>
      
      {settings.emailNotifications && !userEmail && (
        <NoEmailWarning />
      )}
    </div>
  );
};

export default NotificationMethods;
